module.exports = __webpack_public_path__ + "assets/6897524d27dad4f96265874307020164.mp3";